import { isPlatformBrowser } from './general-service';

export function hideFirstViewPreloading () {
	if (isPlatformBrowser()) {
//		let loading = document.getElementById('first-view-pre-loading');
//		let content = document.getElementById('content-section');
	}
}
